import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import * as fieldListStyle from './FieldListStyle';
import { injectIntl } from 'react-intl';
import { createSvgIcon } from '@mui/material/utils';

const ActionBar = ({ intl, data1, checkedItems, selectedCount, onClose, onDelete, onEdit }) => {
  const selectedFields = data1.fields?.filter(field => checkedItems.has(field.fieldId)) || [];
  let displayText = '';


  if (selectedCount === 0) {
    return null;
  }

  const CloseIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z" fill="#191C1C" />
    </svg>,
    'CloseIcon'
  );

  return (
    <Box
      sx={{
        position: 'sticky',
        zIndex: 1100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: '#E6E9E8',
        paddingLeft: '16px',
        borderRadius: '0',
        width: '100%',
        transition: 'box-shadow 0.3s ease',
        height: '48px'
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '16px'
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Box sx={{ padding: '8px' }}>
          <Typography style={fieldListStyle.listRowItem}>{displayText}</Typography>
        </Box>

        {/* Edit Button */}
        <Tooltip
          title={
            <span style={fieldListStyle.iconTextStyle}>
              {intl.formatMessage({ id: 'EDIT' })}
            </span>
          }
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: '#2D3131',
                borderRadius: '4px',
                padding: '4px 8px',
              },
            },
          }}
        >
          <IconButton onClick={onEdit} disabled={selectedCount === 0}>
            <img src="/images/EditIcon.svg" alt="Edit" />
          </IconButton>
        </Tooltip>

        {/* Delete Button */}
        <Tooltip
          title={
            <span style={fieldListStyle.iconTextStyle}>
              {intl.formatMessage({ id: 'DELETE_FIELD' })}
            </span>
          }
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: '#2D3131',
                borderRadius: '4px',
                padding: '4px 8px',
              },
            },
          }}
        >
          <IconButton
            onClick={onDelete}
            sx={{ paddingLeft: '8px' }}
            disabled={selectedCount === 0}
          >
            <img src="/images/DeleteIcon.svg" alt="Delete" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default injectIntl(ActionBar);